import { render } from "./Estudo.vue?vue&type=template&id=fb456d98"
import script from "./Estudo.vue?vue&type=script&lang=js"
export * from "./Estudo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjetosCodes\\Ideias\\admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__